import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { AppealsPage } from './pages/AppealsPage';
import { OutgoingCallsPage } from './pages/OutgoingCallsPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { ContactsPage } from './pages/ContactsPage';
import { IncomingCallsPage } from './pages/IncomingCallsPage';
import { LoginPage } from './pages/LoginPage';
import { QueuePage } from './pages/QueuePage';
import { SettingsPage } from './pages/SettingsPage';
import { ToDoPage } from './pages/ToDoPage';
import { LandingPage } from './pages/LandingPage';

import { useAuth } from './hooks/useAuth';
import { ToastProvider } from './components/common/ToastProvider';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Компонент защищенного маршрута
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <div>Loading...</div>;
  if (!isAuthenticated) return <Navigate to='/admin/login' replace />;
  return <>{children}</>;
};

// TODO (app) add ErrorBoundaty with error page
const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <ToastProvider>
          <CssBaseline />
          <Router>
            <Routes>
              <Route path='/' element={<LandingPage />} />
              <Route path='/admin/login' element={<LoginPage />} />
              <Route path='/admin/campaigns' element={<ProtectedRoute><CampaignsPage /></ProtectedRoute>} />
              <Route path='/admin/outgoing-calls' element={<ProtectedRoute><OutgoingCallsPage /></ProtectedRoute>} />
              <Route path='/admin/incoming-calls' element={<ProtectedRoute><IncomingCallsPage /></ProtectedRoute>} />
              <Route path='/admin/queue' element={<ProtectedRoute><QueuePage /></ProtectedRoute>} />
              <Route path='/admin/appeals' element={<ProtectedRoute><AppealsPage /></ProtectedRoute>} />
              <Route path='/admin/contacts' element={<ProtectedRoute><ContactsPage /></ProtectedRoute>} />
              <Route path='/admin/settings' element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
              <Route path='/admin/todo' element={<ProtectedRoute><ToDoPage /></ProtectedRoute>} />
              <Route path='*' element={<Navigate to='/' replace />} />
            </Routes>
          </Router>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
